import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Input, Progress } from 'reactstrap';
import * as actions from '../../../actions';
import querystring from 'query-string';
import { debounce as _debounce } from 'lodash';
import { getTranslationKey } from '../../../modules/utils/helpers';
import type { Notify } from '../../../typings/redux';
import type { Watermark } from './types';

interface EditWatermarkPreviewProps {
  watermark: Watermark;
  uploadWatermarkImage: (watermarkId: string, file: File, notify: Notify) => Promise<void>;
  notify: Notify;
}

interface EditWatermarkPreviewState {
  previewUrl?: string;
  uploadingWatermarkImage?: boolean;
}

class EditWatermarkPreview extends Component<EditWatermarkPreviewProps, EditWatermarkPreviewState> {
  private setPreviewUrl: () => void;

  constructor(props: EditWatermarkPreviewProps) {
    super(props);
    this.state = {};
    this.watermarkImageSelected = this.watermarkImageSelected.bind(this);

    this.setPreviewUrl = _debounce(this._setPreviewUrl.bind(this), 1500, {
      leading: true
    });
  }

  componentDidMount() {
    this.setPreviewUrl();
  }

  componentDidUpdate() {
    this.setPreviewUrl();
  }

  _setPreviewUrl() {
    const { watermark } = this.props;
    if (
      watermark &&
      ((watermark.type === 'image' && watermark.watermarkPublicKey) || watermark.type === 'text')
    ) {
      const query = querystring.stringify(watermark);
      this.setState({
        previewUrl: window.API_URL + `/api/image/previewWatermark?${query}`
      });
    }
  }

  async watermarkImageSelected(file: File) {
    this.setState({ uploadingWatermarkImage: true });
    const { uploadWatermarkImage, watermark, notify } = this.props;

    await uploadWatermarkImage(watermark._id, file, notify);

    this.setState({ uploadingWatermarkImage: false });
  }

  render() {
    const { watermark } = this.props;
    const { uploadingWatermarkImage } = this.state;
    if (!watermark) return null;

    return (
      <Col
        md={watermark.watermarkPublicKey || watermark.type === 'text' ? 6 : 12}
        sm="12"
        className="text-center"
      >
        {((watermark.type === 'image' && watermark.watermarkPublicKey) ||
          watermark.type === 'text') && (
          <img
            src={this.state.previewUrl}
            className="img-fluid max-h-300 pb-3 m-4"
            alt={getTranslationKey('previewLoading')}
          />
        )}
        {uploadingWatermarkImage && <Progress animated color="success" value="100" />}
        {!uploadingWatermarkImage && watermark.type === 'image' && !watermark.watermarkPublicKey && (
          <div>
            <p className="text-justify text-muted">
              {getTranslationKey('watermark.uploadImageDesc')}
            </p>
            <label className="btn btn-primary cursor-pointer w-100-p">
              <Input
                type="file"
                onChange={({ target: { files } }) => files && this.watermarkImageSelected(files[0])}
                accept="image/*"
                multiple={false}
                className="hidden-upload"
                disabled={uploadingWatermarkImage}
              />
              <i className="icon-picture" /> {getTranslationKey('watermark.uploadImage')}
            </label>
          </div>
        )}
      </Col>
    );
  }
}

interface StateProps {
  notify: Notify;
}

function mapStateToProps({ notify }: StateProps) {
  return { notify };
}
export default connect(mapStateToProps, actions)(EditWatermarkPreview);
